import React from 'react'
import Grid2 from '@mui/material/Unstable_Grid2' // Grid version 2
import { Typography } from '@mui/material'
import { Item } from './Item.js'
const sxLabelItem = {
    // paddingRight: { md: 6 },

    padding: { xs: 0, md: 8 },
}
function LoadingMessage({ msg }) {
    return (
        <>
            <Grid2 xs={12}>
                <Item elevation={3} sx={sxLabelItem}>
                    <Typography variant="h4">{msg}</Typography>
                </Item>
            </Grid2>
        </>
    )
}

export default LoadingMessage
